// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class StorybookEntry {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(entry) {
        var _a, _b;
        this.id = entry.id;
        this.url = entry.url;
        this.createdAt = new Date(entry.createdAt);
        this.updatedAt = new Date(entry.updatedAt);
        this.sourceId = entry.sourceId;
        this.designSystemId = entry.designSystemId;
        this.storyId = entry.storyId;
        this.origin = entry.origin;
        this.aliases = (_a = entry.aliases) !== null && _a !== void 0 ? _a : null;
        this.isDeleted = (_b = entry.isDeleted) !== null && _b !== void 0 ? _b : null;
    }
}
